module.exports = __webpack_public_path__ + "static/media/Imageheader.36e6d8c9.jpg";